import React from "react";
import { useHistory } from "react-router-dom";
import { Typography, Button as MuiButton } from "@mui/material";
import { styled } from "@mui/material/styles";

const Root = styled("div")(({ theme }) => ({
  padding: theme.spacing(6),
  textAlign: "center",
  background: "transparent",

  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(10),
  },
}));

const Unauthorized = () => {
  const history = useHistory();

  return (
    <Root>
      <Typography component="h1" variant="h1" align="center" gutterBottom>
        Unauthorized
      </Typography>
      <Typography component="h2" variant="h5" align="center" gutterBottom>
        {window.location.pathname}
      </Typography>
      <Typography component="h2" variant="body1" align="center" gutterBottom>
        You do not have permission to access this resource.
      </Typography>
      <MuiButton
        onClick={() => {
          history.goBack();
        }}
        variant="contained"
        color="secondary"
        sx={{ marginTop: 2 }}
      >
        Back to Previous Page
      </MuiButton>
    </Root>
  );
};

export default Unauthorized;
